export const UNSET_PSEUDO_DUID = "@unset";
export const UNSET_PROPERTY_PSEUDO_VALUE = UNSET_PSEUDO_DUID;
export const UNCOLORED_PSEUDO_COLOR_BY = UNSET_PSEUDO_DUID;
export const UNPRIORITIZED_PSEUDO_VALUE = "@unprioritized";
export const UNSIZED_PSEUDO_VALUE = "@unsized";
export const UNCHECKED_PSEUDO_VALUE = "@unchecked";
export const CHECKED_PSEUDO_VALUE = "@checked";
export const NULL_PSEUDO_VALUE = "@null";
